import { authData } from './common/state';

export default {
  modules: {
    authData
  }
};
